






















































































import { Component, Vue, Watch } from 'vue-property-decorator'
import filterGroup from '@/components/filterGroup'
import FlexTooltip from '@/components/FlexTooltip.vue'
import { NoticeController, DropDownController } from '@/services/request.service'
import { createPagination } from '@/constant/constant'
import cloneDeep from 'lodash/cloneDeep'
import GroupTransfer from '@/components/GroupTransfer.vue'

import moment from 'moment'
import { toPage } from '@/utils/utils'

@Component({
  components: {
    filterGroup,
    FlexTooltip,
    GroupTransfer,
  },
})
export default class ContentManagement extends Vue {
  private type: string = 'add'
  private noticeDepartmentId: number = 0
  private manageForm: any = {
    departmentName: '',
  }
  private pagination: any = createPagination({ pageSize: 30 })

  private data: Array<any> = [{}]
  private selectedHeadTeachers: Array<any> = []

  private moment = moment
  private loading: boolean = false

  private departmentList: any = []
  private visible: boolean = false
  private transferVisible = false
  private transferCandidate: Array<any> = []
  private transferSelected: Array<any> = []
  private dataLoading: any = false
  private teachers: Array<any> = []

  private statuses: Array<any> = [
    {
      key: true,
      value: 'published',
    },
    {
      key: false,
      value: 'unpublish',
    },
  ]

  private rules: any = {
    departmentName: [
      { required: true, message: this.$t('notice.enterName'), trigger: 'change' },
      { max: 100, message: this.$t('common.textLimit100'), trigger: 'blur' },
    ],
  }

  private get locale(): any {
    return this.$store.state.locale
  }

  private get ratio(): any {
    return this.$store.state.ratio || 1
  }

  private get columns(): Array<any> {
    return [
      {
        key: 'name',
        dataIndex: 'name',
        title: this.$t('notice.department'),
        ellipsis: true,
        scopedSlots: { customRender: 'name' },
        width: 200 * this.ratio,
      },
      {
        key: 'publishers',
        ellipsis: true,
        title: this.$t('notice.publishers'),
        scopedSlots: { customRender: 'publishers' },
        width: 550 * this.ratio,
      },
      {
        key: 'creater',
        dataIndex: 'creator',
        title: this.$t('notice.creater'),
        width: 250 * this.ratio,
      },
      {
        key: 'operations',
        title: this.$t('notice.operations'),
        align: 'left',
        scopedSlots: { customRender: 'operations' },
        width: 100 * this.ratio,
      },
    ].filter(item => item)
  }
  @Watch('$route', { immediate: true })
  private onRouteChange(to, from): void {
    this.refresh()
  }

  private handleTableChange(pagination): void {
    this.$set(this.pagination, 'current', pagination.current)
    this.$set(this.pagination, 'pageSize', pagination.pageSize)
    this.getData(pagination)
  }

  /**
   * 部门相关
   */
  private edit(type: string, record?: any): void {
    if (type === 'delete') {
      NoticeController.deleteDepart(record.noticeDepartmentId)
        .then(res => {
          this.$message.success(this.$tc('common.deleteSuccess'))
        })
        .catch(err => console.error(err))
        .finally(() => {
          this.refresh()
        })
      return
    }
    this.type = type
    if (type === 'edit') {
      this.manageForm.departmentName = record.name
      this.selectedHeadTeachers = record.publishers.map(item => {
        return {
          id: item.key,
          title: item.value,
        }
      })
      this.noticeDepartmentId = record.noticeDepartmentId
    }

    this.visible = true
  }

  private handleCancel(): void {
    this.noticeDepartmentId = 0
    this.manageForm.departmentName = ''
    this.selectedHeadTeachers = []
    this.visible = false

    this.selectedHeadTeachers = []
    const form = this.$refs['manageForm'] as any
    form.resetFields()
  }

  private validateName(rule, value, callback): void {
    const form = this.manageForm
    const name = value.trim()
    if (name) {
      if (name.length > 100) {
        callback(this.$t('common.textLimit100'))
      } else {
        const existNames = this.data.map(item => item.name)
        if (existNames.includes(name)) {
          if (
            this.type === 'edit' &&
            this.data.filter(item => item.noticeDepartmentId === this.noticeDepartmentId)[0]
              .name === name
          ) {
            callback()
          } else {
            callback(this.$t('notice.duplicatedName'))
          }
        } else {
          callback()
        }
      }
    } else {
      callback(this.$t('notice.enterName'))
    }
  }

  private confirmEditDep(noticeId): void {
    const form = this.$refs.manageForm as any
    form.validate(valid => {
      if (valid) {
        let condition = {
          noticeDepartmentId: this.noticeDepartmentId ? this.noticeDepartmentId : undefined,
          name: this.manageForm.departmentName,
          publishers: this.selectedHeadTeachers.map(item => {
            return item.id
          }),
        }
        NoticeController.saveDepart(condition)
          .then(res => {
            this.$message.success(this.$tc('common.saveSuccess'))
          })
          .catch(err => console.error(err))
          .finally(() => {
            this.handleCancel()
            this.refresh()
          })
      }
    })
  }

  private getSelectedData(selectedData): void {
    this.selectedHeadTeachers = cloneDeep(selectedData)
  }

  private addHeadTeacher(): void {
    this.transferVisible = true
    this.transferCandidate = this.teachers
    this.transferSelected = this.selectedHeadTeachers
  }

  private removeSelectedHeaderTeacher(id): void {
    const index = this.selectedHeadTeachers.findIndex(item => item.id === id)
    this.selectedHeadTeachers.splice(index, 1)
  }

  private getTransferInfo(): void {
    this.dataLoading = true
    DropDownController.personList(true)
      .then(res => {
        this.teachers = res.data.map(teacher => {
          return {
            id: teacher.key,
            title: (
              (teacher.enValue ? teacher.enValue : '') +
              ' ' +
              (teacher.value ? teacher.value : '')
            ).trim(),
            selected: false,
          }
        })
      })
      .finally(() => {
        this.dataLoading = false
      })
  }

  private getData(page = { pageSize: this.pagination.defaultPageSize, current: 1 }): void {
    if (this.loading) return

    this.data = []
    this.loading = true
    NoticeController.getNoticeDeparts()
      .then(res => {
        this.data = res.data
        this.pagination.current = page.current
        toPage(page, this.data, page => {
          this.pagination.current = page
          this.refresh()
        })
      })
      .catch(err => {
        console.error(err)
      })
      .finally(() => {
        this.loading = false
      })
  }

  private refresh(): void {
    this.getData(this.pagination)
    this.getTransferInfo()
  }
}
